<template>
    <div id="main">
        <div  id="viewer1" v-show="this.pshow">
            <h4 style="text-align:center">房间VR全景图</h4>
            <!-- <p style="font-size:16px;margin:0px; padding:0px;">目前经纬度</p>
            <div style="float:left"><p style="font-size:12px;margin:0px; padding:0px;">经度：</p><span style="font-size:12px;float:left" id="long"></span></div>
            <div style="float:right"><p style="font-size:12px;margin:0px; padding:0px;">纬度：</p><span style="font-size:12px" id="lat"></span></div> -->
        </div>
    </div>    
</template>
<script>
import {Viewer} from 'photo-sphere-viewer'
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
export default {
    data() {
        return {
            pshow:true,
            use:true,
            psv:'',
            id:'',
            readyLoad:'',
            imageLoaded:'',
            longitude:'',//目前经度
            latitude:'',//目前纬度
            marker3:require('../assets/logo.png'),
            imageloading:[
                {
                    imgurl:require('../assets/93758.jpg'),                  
                },
                {
                    imgurl:require('../assets/0100.jpg'),                    
                }
            ],   
        };
    },
    setup () {
        
    },
    mounted () {
        this.initPhotoSphere(this.imageloading[0]);
      
    },
    methods: {
        initPhotoSphere:function(temp_img){
                const viewers=new Viewer({
                // Container
                container: document.getElementById('viewer1'),
                // Panorama, given in base 64
                panorama: temp_img.imgurl,
                // // Deactivate the animation
                // time_anim: false,
                caption: '房间全景图',
                // Display the navigation bar
                navbar:true,
                size: {
                    width: '100%',
                    height: this.isMobile() ? screen.availHeight : '800px'
                },
                plugins: [
                   
                ],
            });


            viewers.on('position-updated',function(po){
                var span1 = document.getElementById('long');
                span1.innerHTML = po.args[0].longitude;
                var span2 = document.getElementById('lat');
                span2.innerHTML = po.args[0].latitude;            
            })
        },
        isMobile() {

        let ua = navigator.userAgent;

        let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),

            isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
            isAndroid = ua.match(/(Android)\s+([\d.]+)/),
            isMobile = isIphone || isAndroid;
            return isMobile;

        }
    }
}
</script>

<style>
    .hi{
        color: red;
        font-size: 20px;
        text-align: left;
    }
</style>